import { AiSparkle16 } from 'ui/icons/aurora/16px/AiSparkle16';
import { ProgressSpinnerContainer, Progress, Sparkle } from './ProgressSpinner.styled';

interface ProgressSpinnerProps {
  /** Width of the loader */
  width?: number;
  /** Loading progress as a percentage */
  progress?: number;
  /** Duration of the loading animation. If provided, will override the specific progress value */
  duration?: number;
}

export const ProgressSpinner = ({
  width = 34,
  progress = 0,
  duration,
  ...props
}: ProgressSpinnerProps) => {
  return (
    <ProgressSpinnerContainer $width={width} progress={progress} {...props}>
      <Progress progress={progress} duration={duration} />
      <Sparkle>
        <AiSparkle16 />
      </Sparkle>
    </ProgressSpinnerContainer>
  );
};
